<!--nav1-->
<app-main-nav-bar></app-main-nav-bar>
<!--page-->
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-heading"></div>
      <div class="card-body">
        <h3 class="title">درباره ما</h3>
        <br>
        <p style="text-align: justify;">
            هشتگ بیمه با شعار شفافیت، آگاهی و انعطاف پذیری در صنعت بیمه متولد شد ما می خواهیم برای شما یک دستیار شخصی بیمه باشیم و در یافتن بهترین خدمات بیمه ای شما را یاری دهیم.
          ما بر این باوریم که ارائه خدمات بیمه بصورت آنلاین از ثبت سفارش آنلاین باید به فروش آنلاین تبدیل شود و در راه قدم نهادیم تا این امکان را به عنوان یک دستیار شخصی ایجاد نماییم و روند فرآیند خرید یک محصول بیمه را از لحظه درخواست دریافت بیمه نامه بصورت کاملا آنلاین در کمترین زمان فراهم سازیم.
        </p>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
